import * as React from 'react';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import CleaningServices from '@mui/icons-material/CleaningServices';
import Edit from "@mui/icons-material/Edit";
import {Slider} from "@mui/material";

interface ActionInterface {
  icon: any,
  name: string,
  code: string
}


export default function SelectSettings({selectionState, setSelectionState, radius, setRadius}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const marks = [
    {
      value: 0,
      label: '500',
    },
    {
      value: 1,
      label: '2000',
    },
    {
      value: 2,
      label: '4500',
    },

  ];



  return (



        <Slider

          onChangeCommitted={(e, value) => {
            setRadius(value)
          }}
          defaultValue={1}
          orientation="horizontal"
          getAriaValueText={(value) => {
            if (value === 0) {
              return "Маленький"
            }
            if (value === 1) {
              return "Средний"
            }
            if (value === 2) {
              return "Большой"
            }
          }}
          valueLabelDisplay="off"
          step={1}
          marks={marks}
          min={0}
          max={2}
          componentsProps={{markLabel: {style: {color:"white"}}}}
        />

  );
}
